import { render } from "./VerticalSteps.vue?vue&type=template&id=23f9e5ae"
import script from "./VerticalSteps.vue?vue&type=script&lang=js"
export * from "./VerticalSteps.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__